import React from 'react';
import DynamicFormViewer from '../../Components/FormData/DynamicFormViewer';
import {
  getAllBookAlternativeTherapies,
  deleteBookAlternativeTherapies,
  updateBookAlternativeTherapiesById,
} from '../../Redux/Store/API/FormsData/BookAlternativeTherapies';

export default function BookAlternativePackageFormData() {
  const headers = [
    { key: 'firstname', label: 'First Name' },
    { key: 'lastname', label: 'Last Name' },
    { key: 'mobileNo', label: 'Mobile No' },
    { key: 'therapyName', label: 'Therapy Name' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'gender', label: 'Gender' },
    { key: 'description', label: 'Description' },
    { key: 'sourcePage', label: 'Source Page', render: (v) => v || '—' },
  ];

  return (
    <DynamicFormViewer
      title="Book Alternative Therapies"
      headers={headers}
      fetchAction={getAllBookAlternativeTherapies}
      deleteAction={deleteBookAlternativeTherapies}
      updateAction={updateBookAlternativeTherapiesById}
      stateSliceName="bookAlternativeTherapies"
      dataKey="getallBookAlternativeTherapies"
    />
  );
}